import { type IContextualAction } from '@principle-theorem/ng-principle-shared';
import { type IPrincipleMention } from '@principle-theorem/principle-core/interfaces';

export interface ICreateAction extends IContextualAction {
  do(resource?: IPrincipleMention): Promise<void> | void;
}
